import React from "react";
import VideoComponent from "../util/VideoComponent";

const VideosComponent = (props) => {
    return (
        <div>
            {/*Videos*/}
            {/*  From Permanent Collection  */}
            <VideoComponent id="NANINTV083" src={process.env.PUBLIC_URL + `/videos/NANINTV083.mp4`}/>
            {/*  From Permanent Collection  */}

            {/*Audio*/}
            {/*  From Permanent Collection  */}
            <VideoComponent id="NANINTA083" src={process.env.PUBLIC_URL + `/audio/NANINTA083.mp3`} audio="Y"/>
            {/*  From Permanent Collection  */}

            {/*<VideoComponent id="S02P07A01" src={process.env.PUBLIC_URL + `/audio/S02P07A01.mp3`} audio="Y"/>*/}
            <VideoComponent id="VENCPA_A050_I" src={process.env.PUBLIC_URL + `/audio/VENCPA_A050_I.mp3`} audio="Y"/>
            <VideoComponent id="VENGLA_A052_I" src={process.env.PUBLIC_URL + `/audio/VENGLA_A052_I.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A002_E" src={process.env.PUBLIC_URL + `/audio/VENREL_A002_E.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A002_I" src={process.env.PUBLIC_URL + `/audio/VENREL_A002_I.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A006_E" src={process.env.PUBLIC_URL + `/audio/VENREL_A006_E.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A006_I" src={process.env.PUBLIC_URL + `/audio/VENREL_A006_I.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A013_E" src={process.env.PUBLIC_URL + `/audio/VENREL_A013_E.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A013_I" src={process.env.PUBLIC_URL + `/audio/VENREL_A013_I.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A016_E" src={process.env.PUBLIC_URL + `/audio/VENREL_A016_E.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A016_I" src={process.env.PUBLIC_URL + `/audio/VENREL_A016_I.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A020_E" src={process.env.PUBLIC_URL + `/audio/VENREL_A020_E.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A020_I" src={process.env.PUBLIC_URL + `/audio/VENREL_A020_I.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A049_I" src={process.env.PUBLIC_URL + `/audio/VENREL_A049_I.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A070_E" src={process.env.PUBLIC_URL + `/audio/VENREL_A070_E.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_A070_I" src={process.env.PUBLIC_URL + `/audio/VENREL_A070_I.mp3`} audio="Y"/>
            <VideoComponent id="VENREL_ANN_A065_I" src={process.env.PUBLIC_URL + `/audio/VENREL_ANN_A065_I.mp3`}
                            audio="Y"/>
            <VideoComponent id="VENREL_COR_A068_I" src={process.env.PUBLIC_URL + `/audio/VENREL_COR_A068_I.mp3`}
                            audio="Y"/>
            <VideoComponent id="VENREL_CRU_A066_I" src={process.env.PUBLIC_URL + `/audio/VENREL_CRU_A066_I.mp3`}
                            audio="Y"/>
            <VideoComponent id="VENREL_MAD_A069_I" src={process.env.PUBLIC_URL + `/audio/VENREL_MAD_A069_I.mp3`}
                            audio="Y"/>
            <VideoComponent id="VENREL_RES_A067_I" src={process.env.PUBLIC_URL + `/audio/VENREL_RES_A067_I.mp3`}
                            audio="Y"/>
            <VideoComponent id="VENSRM_A072_I" src={process.env.PUBLIC_URL + `/audio/VENSRM_A072_I.mp3`} audio="Y"/>
            <VideoComponent id="VENWEL_A073_I" src={process.env.PUBLIC_URL + `/audio/VENWEL_A073_I.mp3`} audio="Y"/>


        </div>
    )
}

export default VideosComponent;
